$(document).ready(function() {
  var timeout = null;

  removeNestedRequiedFields(timeout);

  const callremoveNestedRequiedFields = () => removeNestedRequiedFields(timeout);
  window.callremoveNestedRequiedFields = callremoveNestedRequiedFields;

  $('body').on('click', '.remove_fields', function() {
    var nestedWrapper = $(this).parents('.nested-fields');
        nestedWrapper.find('input._destroy_field').val(true);
        nestedWrapper.find('input[required="required"]').removeAttr('required');
        nestedWrapper.addClass('d-none')
  });

  $('body').on('click', '.add_fields', function() {
    removeNestedRequiedFields();
  });

  function removeNestedRequiedFields(timeout){
    if ($('.remove_fields').length > 0) {
      $('.remove_fields').click(function(){
        var field_idx = $(this).attr('data-field-idx');

        if (field_idx != undefined || field_idx != null) {
          $(`.nested-idx-${field_idx}`).removeAttr('required');
        }
      });
    }
  }
})